import { keys, max, omit, toNumber,  } from 'lodash';

export const ContentItemTypes = {
  product: 0,
  addDocument: 3,
  webPage: 8,
  virtualTray: 9,
  galleryImages: 10,
  customPattern: 12,
};

export const Roles =  {
  everyone : 'everyone',
}

const headers = {
  config: 'contentWizard.Label.ChooseContentType',
  product: 'contentWizard.Label.ChooseProduct',
  colors: 'contentWizard.Label.ChooseColors',
  featureImage: 'contentWizard.Label.ChooseFeatureImages',
};

const editColorImgHeaders = {
  1: 'contentWizard.Label.EditColors',
  2: 'contentWizard.Label.EditFeatureImages'
}
const virtualTrayHeaders = {
  virtualTray: 'contentWizard.Label.ChooseVirtualTray',
  Configuration: 'contentWizard.Label.Configuration',
};
const galleryImageHeader = {
  galleryImage:'contentWizard.Label.ChooseImage'
};

const documentHeader = {
  chooseDocument:'contentWizard.Label.ChooseDocument'
}

export const BoardRoles = {
  viewer: 0,
  commenter: 1,
  collaborator: 2,
  owner: 3,
};

export const isOwner = (role) => role === BoardRoles.owner;
export const isCollaborator = (role) => role === BoardRoles.collaborator;
export const isCommenter = (role) => role === BoardRoles.commenter;
export const isViewer = (role) => role === BoardRoles.viewer;

export const stepTree = {
  [ContentItemTypes.product]: {
    lastStep: 4,
    steps: {
      headers: {
        1: headers.config,
        2: headers.product,
        3: headers.colors,
        4: headers.featureImage,
      },
    },
    isCart: true
  },
  [ContentItemTypes.virtualTray]: {
    lastStep: 3,
    steps: {
      headers:  {
        1: headers.config,
        2: virtualTrayHeaders.virtualTray,
        3: virtualTrayHeaders.Configuration,
      },
    },
    isCart: true
  },
  [ContentItemTypes.customPattern]: {
    lastStep: 3,
    steps: {
      headers: editColorImgHeaders,
    },
    isCart: true
  },
  [ContentItemTypes.webPage]: {
    lastStep: 2,
    steps: {
      headers:  {
        1: headers.config,
        2: 'contentWizard.label.chooseWebPage',
      },
    },
    isCart: false
  },
  [ContentItemTypes.galleryImages]: {
    lastStep: 3,
    steps: {
      headers:  {
        1: headers.config,
        2: galleryImageHeader.galleryImage,
        3: virtualTrayHeaders.Configuration,
      },
    },
    isCart: false
  },
  [ContentItemTypes.addDocument]: {
    lastStep: 3,
    steps: {
      headers:  {
        1: headers.config,
        2: documentHeader.chooseDocument,
        3: virtualTrayHeaders.Configuration,
      },
    },
    isCart: false
  },
};

export const getStepComponent = (type, step) => {
  return stepTree[type];
};

export const getStepHeaders = (type, keyToIgnore = 0) => {
  return (keyToIgnore != 0) ? omit(stepTree[type]?.steps.headers, [keyToIgnore]) : stepTree[type]?.steps.headers
};

export const isLastStep = (type, num, isOutOfProject, itemBoardId) => {
  if(stepTree[type]?.lastStep <= num)
  {
    if(isOutOfProject){
      return stepTree[type]?.lastStep < num;
    }
    return true;
  }
  return false;
};

export const mapToStep1Type = (contentType) => {
  switch (contentType) {
    case ContentItemTypes.product:
      return 'product';
    case ContentItemTypes.virtualTray:
      return 'virtualtray';
      case ContentItemTypes.galleryImages:
      return 'galleryimages';
    case ContentItemTypes.addDocument:
      return 'addDocument';
    case ContentItemTypes.webPage:
      return 'webPage';
    default:
      return 'page';
  }
};

//customData:
export const step1Data = {
    product: {
      label: 'contentWizard.Label.Products',
      description: 'contentWizard.Description.Products',
      className: 'product-icon-myProject',
      types: [ContentItemTypes.product, ContentItemTypes.paint, ContentItemTypes.customPattern],
      defaultType: ContentItemTypes.product,
      roles: [Roles.everyone]
    },
    virtualTray: {
      label: 'contentWizard.Label.VirtualTray',
      description: '',
      className: 'collection-icon-myProject',
      types: [ContentItemTypes.virtualTray],
      defaultType: ContentItemTypes.virtualTray,
      roles: [Roles.everyone]
    },
    galleryImages: {
      label: 'contentWizard.Label.GalleryImages',
      description: 'contentWizard.Description.GalleryImages',
      className: 'gallery-images-icon-myProject',
      types: [ContentItemTypes.galleryImages],
      defaultType: ContentItemTypes.galleryImages,
      roles: [Roles.everyone]
    },
    addDocument:{
      label: 'contentWizard.Label.Documents',
      description: 'contentWizard.Description.AddDocument',
      className: 'add-document-icon-myProject',
      types: [ContentItemTypes.addDocument],
      defaultType: ContentItemTypes.addDocument,
      roles: [Roles.everyone]
    },
    webPage: {
      label: 'contentWizard.label.webPage',
      description: 'contentWizard.description.webPage',
      className: 'web-page-icon-myProject',
      types: [ContentItemTypes.webPage],
      defaultType: ContentItemTypes.webPage,
      roles: [Roles.everyone]
    },
  }

   export function checkForRoleMatch(role) {
    if (role === 'everyone') {
      return true;
    }
    return true;
  }

  export function hasRole(role) {
    if (!role) {
      return false;
    }
    if (Array.isArray(role)) {
      return role.some(checkForRoleMatch.bind(this));
    }
    return checkForRoleMatch.call(this, role);
  }
